import { render, staticRenderFns } from "./InfoCardList.vue?vue&type=template&id=18531e29&scoped=true&"
import script from "./InfoCardList.vue?vue&type=script&lang=ts&"
export * from "./InfoCardList.vue?vue&type=script&lang=ts&"
import style0 from "./InfoCardList.vue?vue&type=style&index=0&id=18531e29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18531e29",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
